module.exports = __webpack_public_path__ + "static/full-86959dc79f11ea20af5a8a4734ccb8ac.jpg";